import { CUSTOMER_JOURNEY_LOGIN_RESERVATION_ERROR } from '../const';

function action(errorCallback) {
  return { type: CUSTOMER_JOURNEY_LOGIN_RESERVATION_ERROR, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyLoginReservationError.js